// src/components/BottomNav.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";

const BottomNav = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer
      className="bg-gray-800 text-white py-6 md:py-8 w-full"
      style={{ backgroundColor: '#54BD95', transition: 'background-color 0.3s ease-in-out' }}
    >
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 text-center md:text-left">

        {/* Logo and About Us */}
        <div>
          <div className="text-xl md:text-2xl font-bold mb-3 md:mb-4 transform transition-transform duration-200 hover:scale-105">
            <Link to="/" onClick={scrollToTop} className="hover:text-gray-300">
              PlacezioEstate
            </Link>
          </div>
          <p className="text-sm md:text-base text-white">
            Discover your ideal property with PlacezioEstate. We connect you with the best real estate options in prime locations.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-base md:text-lg font-semibold mb-2 md:mb-3">Quick Links</h3>
          <ul className="space-y-1 md:space-y-2">
            <li><Link to="/termsandcondition" onClick={scrollToTop} className="hover:text-gray-300 text-sm md:text-base">Terms and Conditions</Link></li>
            <li><Link to="/" onClick={scrollToTop} className="hover:text-gray-300 text-sm md:text-base">Privacy Policy</Link></li>
            <li><Link to="/" onClick={scrollToTop} className="hover:text-gray-300 text-sm md:text-base">FAQ</Link></li>
            {/* <li><Link to="/login" onClick={scrollToTop} className="hover:text-gray-300 text-sm md:text-base">Login</Link></li> */}
          </ul>
        </div>

        {/* Contact Us */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-base  md:text-lg font-semibold mb-2 md:mb-3">Contact Us</h3>
          <ul className="space-y-1 md:space-y-2 text-xs md:text-sm">
            <li className="flex items-center space-x-2">
              <FaPhoneAlt className="text-white" />
              <a href="tel:8318150076" className="hover:text-gray-300 text-base">+91 8318150076</a>
            </li>
            <li className="flex items-center space-x-2">
              <FaEnvelope className="text-white" />
              <a href="mailto:info@placezioestate.com" className="hover:text-gray-300 text-base">info@placezioestate.com</a>
            </li>
          </ul>
        </div>


        {/* Follow Us */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-base md:text-lg font-semibold mb-2 md:mb-3">Follow Us</h3>
          <div className="flex justify-center  space-x-3 md:space-x-4">
            <a href="https://www.facebook.com/share/18yDGd614x/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:text-gray-300 text-sm md:text-base">
              <FaFacebookF className="text-white" />
              <span>Facebook</span>
            </a>
            {/* <a href="https://twitter.com/placezioestate" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:text-gray-300 text-sm md:text-base">
              <FaTwitter className="text-green-800" />
              <span>Twitter</span>
            </a> */}
            <a href="https://www.instagram.com/placezioestate?igsh=bmRnZmU3d2Y1bTBm&utm_source=qr" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:text-gray-300 text-sm md:text-base">
              <FaInstagram className="text-white" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="container mx-auto px-4 mt-6 md:mt-8 border-t border-white pt-3 md:pt-4 text-xs md:text-sm text-white text-center md:text-left">
        <p>&copy; 2025 Placezio Estate. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default BottomNav;
